<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2022-05-16 10:21:00
 * @Description: 标记列表
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <div class="position-absolute" id="marker_list">
      <span
        class="iconfont icon-close cur-pointer position-absolute close_icon"
        @click="closeDialog"
      ></span>
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick" class="h-100">
        <el-tab-pane label="标记列表" name="markerList">
          <el-tree
            :data="treeData"
            :props="defaultProps"
            @node-click="handleNodeClick"
            default-expand-all
          >
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }}</span>
              <span v-if="data.level != 1">
                <el-tooltip content="查看" placement="top" effect="dark" :open-delay="1000">
                  <el-button
                    type="info"
                    icon="el-icon-view"
                    @click.stop="showMarker(data)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="删除" placement="top" effect="dark" :open-delay="1000">
                  <el-button
                    v-if="data.canDelete === 1"
                    type="danger"
                    icon="el-icon-delete"
                    @click.stop="removeMarker(data)"
                  ></el-button>
                </el-tooltip>
                <el-tooltip content="分享" placement="top" effect="dark" :open-delay="1000">
                  <el-button
                    class="el-icon-share"
                    type="primary"
                    @click.stop="shareMarker(data)"
                  ></el-button>
                </el-tooltip>
              </span>
            </span>
          </el-tree>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 分享标记弹框 -->
    <saveOrShareMarker
      v-if="showShareDialog"
      :title="componentTitle"
      :disableName="true"
      :formLabelAlign="formLabelAlign"
      @closeComponents="closeShareDialog"
    ></saveOrShareMarker>
  </div>
</template>

<script>
import DocumentManagementService from '@/services/documentManagement'
import Marker from '@/services/marker'
const saveOrShareMarker = () => {
  return import('../components/photoEdit/saveOrShareMarker')
}
export default {
  props: {
    fileId: {
      type: String,
      default: ' ',
    },
  },
  components: {
    saveOrShareMarker,
  },
  watch: {
    fileId() {
      this.getMarkerList()
    },
  },
  data() {
    return {
      activeName: 'markerList',
      treeData: [
        {
          level: 1,
          label: '我的标记',
          children: [],
        },
        {
          level: 1,
          label: '别人分享的标记',
          children: [],
        },
      ],
      defaultProps: {
        children: 'children',
        label: 'label',
      },
      formLabelAlign: {},
      componentTitle: '分享标记',
      showShareDialog: false,
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
  },
  created() {
    // 获取标记列表
    this.getMarkerList()
  },
  methods: {
    /**
     * @description: 获取标记列表
     * @param {*}
     * @return {*}
     */

    async getMarkerList() {
      const query = {
        siteid: this.currentProject ? this.currentProject.id : ' ',
        pagesize: 999,
        pageno: 1,
        documentfileid: this.fileId,
      }
      this.treeData = this.$options.data().treeData
      const res = await Marker.getDistinctList(query)
      if (res && res.code === 0 && res.data) {
        _.forEach(res.data, (el) => {
          if (el.classify === 1) {
            // 我的标记
            this.treeData[0].children.push({
              label: el.name,
              ...el,
              level: 2,
            })
          } else {
            this.treeData[1].children.push({
              label: el.name,
              ...el,
              level: 2,
            })
          }
        })
      }
    },
    closeDialog() {
      this.$emit('closeComponents')
    },
    // 关闭分享弹框
    closeShareDialog() {
      this.showShareDialog = false
    },
    /**
     * @description: 打开分享弹框
     * @param {*} data
     * @return {*}
     */

    shareMarker(data) {
      this.formLabelAlign = {
        ...data,
      }
      this.showShareDialog = true
    },
    /**
     * @description: 删除标记
     * @param {*} data
     * @return {*}
     */

    removeMarker(data) {
      this.$confirm('此操作将永久删除该条标记, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await Marker.deleteMark([data.id])
          if (res && res.code === 0 && res.data) {
            this.$message.success('删除成功')
            this.getMarkerList()
          } else {
            this.$message.error(res.message)
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          })
        })
    },
    // tab点击事件
    handleClick(node) {},
    /**
     * @description: 标记查看
     * @param {*} node
     * @return {*}
     */

    showMarker(node) {
      // 切换为查看标记状态
      this.$emit('showMarker', node)
    },
    handleNodeClick(node) {
      const info = JSON.parse(node.cameraPosition)
      // 文件or模型定位
      if (node.cameraPosition) {
        if (node.markType === '2') {
          window.player.Native.Camera.moveTo(info.eye, info.target, info.up, 2)
        } else if (node.markType === '1') {
          // 文件定位
          this.$emit('changeFileLocation', info)
        }
      }
    },
    /**
     * @description: 跳转 查看详情
     * @param {*}
     * @return {*}
     */

    goPhotoEdit(data) {
      this.$router.push({
        name: 'photoEdit',
        params: {
          detail: data,
          type: 'showMark',
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>

#marker_list {
  height: 450px;
  width: 400px;
  left: 6px;
  top: 44px;
  box-shadow: 0px 0px 1px 4px #dcdbdbff;
  border-radius: 4px;
  z-index: 99;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.close_icon {
  top: 12px;
  right: 12px;
  z-index: 1;
}
/deep/ .el-tabs {
  background: #ffffff !important;
  border-color: #ffffff !important;
  &__content {
    height: 88%;
    overflow: scroll;
  }
}

</style>
